/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { CancelInvestigationRequest } from '../models';
import { ClosedInvestigationDetails } from '../models';
import { CompletedInvestigationDetails } from '../models';
import { InvestigationAccountingAppViewIEnumerableResponse } from '../models';
import { InvestigationAccountingAppViewResponse } from '../models';
import { InvestigationBreachViewIEnumerableResponse } from '../models';
import { InvestigationDetailViewResponse } from '../models';
import { InvestigationDetailsRequest } from '../models';
import { InvestigationFilterRequest } from '../models';
import { InvestigationRequest } from '../models';
import { InvestigationViewIEnumerableResponse } from '../models';
import { InvestigationViewResponse } from '../models';
import { NumberOfInvestigationViewResponse } from '../models';
import { NumberOfInvestigationsPerInvestigatorViewIEnumerableResponse } from '../models';
import { TrustTeamMemberInvestigationFilterRequest } from '../models';
/**
 * InvestigationApi - axios parameter creator
 * @export
 */
export const InvestigationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA SuperAdmin | Cancel Investigation
         * @param {CancelInvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationCancelInvestigationPost: async (body?: CancelInvestigationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/CancelInvestigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Accounting Apps by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationAccountingAppsById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ta All | Returns Investigation Accounting Details by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationAccountingDetailsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Breaches by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationBreachesById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Details by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationDetailsById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ta All | Returns Latest Investigation by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigations by TrustMemberId
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost: async (body?: TrustTeamMemberInvestigationFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetInvestigationsByTrustTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigations
         * @param {InvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsPost: async (body?: InvestigationFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetInvestigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetNumberOfInvestigationsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetNumberOfInvestigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations Per Investigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetNumerOfInvestigationsPerInvestigator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns boolean value, if practice has investigations with status: Created, Ongoing
         * @param {number} [practiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetPracticeHasInvestigationGet: async (practiceId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetPracticeHasInvestigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (practiceId !== undefined) {
                localVarQueryParameter['practiceId'] = practiceId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Save Investigation
         * @param {InvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationPost: async (body?: InvestigationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/SaveInvestigation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {ClosedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateClosedInvestigationDetailsPost: async (body?: ClosedInvestigationDetails, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/UpdateClosedInvestigationDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {CompletedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateCompletedInvestigationDetailsPost: async (body?: CompletedInvestigationDetails, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/UpdateCompletedInvestigationDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All  | Update Investigation Details
         * @param {InvestigationDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateInvestigationDetailsPost: async (body?: InvestigationDetailsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/UpdateInvestigationDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestigationApi - functional programming interface
 * @export
 */
export const InvestigationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA SuperAdmin | Cancel Investigation
         * @param {CancelInvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationCancelInvestigationPost(body?: CancelInvestigationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationCancelInvestigationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Accounting Apps by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAccountingAppViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Ta All | Returns Investigation Accounting Details by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAccountingAppViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Breaches by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationBreachViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Details by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDetailViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Ta All | Returns Latest Investigation by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigations by TrustMemberId
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigations
         * @param {InvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationsPost(body?: InvestigationFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetNumberOfInvestigationsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberOfInvestigationViewResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetNumberOfInvestigationsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations Per Investigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberOfInvestigationsPerInvestigatorViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns boolean value, if practice has investigations with status: Created, Ongoing
         * @param {number} [practiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetPracticeHasInvestigationGet(practiceId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetPracticeHasInvestigationGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Save Investigation
         * @param {InvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigationPost(body?: InvestigationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {ClosedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationUpdateClosedInvestigationDetailsPost(body?: ClosedInvestigationDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationUpdateClosedInvestigationDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {CompletedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body?: CompletedInvestigationDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All  | Update Investigation Details
         * @param {InvestigationDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationUpdateInvestigationDetailsPost(body?: InvestigationDetailsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationUpdateInvestigationDetailsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InvestigationApi - factory interface
 * @export
 */
export const InvestigationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA SuperAdmin | Cancel Investigation
         * @param {CancelInvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationCancelInvestigationPost(body?: CancelInvestigationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationCancelInvestigationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Accounting Apps by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationAccountingAppViewResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ta All | Returns Investigation Accounting Details by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationAccountingAppViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Breaches by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationBreachViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationViewResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Details by InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationDetailViewResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ta All | Returns Latest Investigation by PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigations by TrustMemberId
         * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigations
         * @param {InvestigationFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsPost(body?: InvestigationFilterRequest, options?: any): AxiosPromise<InvestigationViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetNumberOfInvestigationsGet(options?: any): AxiosPromise<NumberOfInvestigationViewResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetNumberOfInvestigationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Number Of Investigations Per Investigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options?: any): AxiosPromise<NumberOfInvestigationsPerInvestigatorViewIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns boolean value, if practice has investigations with status: Created, Ongoing
         * @param {number} [practiceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetPracticeHasInvestigationGet(practiceId?: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetPracticeHasInvestigationGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Save Investigation
         * @param {InvestigationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationPost(body?: InvestigationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {ClosedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateClosedInvestigationDetailsPost(body?: ClosedInvestigationDetails, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationUpdateClosedInvestigationDetailsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All  | Update Completed Investigation Details
         * @param {CompletedInvestigationDetails} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body?: CompletedInvestigationDetails, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All  | Update Investigation Details
         * @param {InvestigationDetailsRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationUpdateInvestigationDetailsPost(body?: InvestigationDetailsRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationUpdateInvestigationDetailsPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestigationApi - object-oriented interface
 * @export
 * @class InvestigationApi
 * @extends {BaseAPI}
 */
export class InvestigationApi extends BaseAPI {
    /**
     * 
     * @summary TA SuperAdmin | Cancel Investigation
     * @param {CancelInvestigationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationCancelInvestigationPost(body?: CancelInvestigationRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationCancelInvestigationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Accounting Apps by InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Ta All | Returns Investigation Accounting Details by PracticeId
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Breaches by InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation by InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Details by InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Ta All | Returns Latest Investigation by PracticeId
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigations by TrustMemberId
     * @param {TrustTeamMemberInvestigationFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body?: TrustTeamMemberInvestigationFilterRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationsByTrustTeamMemberIdPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigations
     * @param {InvestigationFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationsPost(body?: InvestigationFilterRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Number Of Investigations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetNumberOfInvestigationsGet(options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetNumberOfInvestigationsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Number Of Investigations Per Investigator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetNumerOfInvestigationsPerInvestigatorGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns boolean value, if practice has investigations with status: Created, Ongoing
     * @param {number} [practiceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetPracticeHasInvestigationGet(practiceId?: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetPracticeHasInvestigationGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Save Investigation
     * @param {InvestigationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigationPost(body?: InvestigationRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All  | Update Completed Investigation Details
     * @param {ClosedInvestigationDetails} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationUpdateClosedInvestigationDetailsPost(body?: ClosedInvestigationDetails, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationUpdateClosedInvestigationDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All  | Update Completed Investigation Details
     * @param {CompletedInvestigationDetails} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body?: CompletedInvestigationDetails, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationUpdateCompletedInvestigationDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All  | Update Investigation Details
     * @param {InvestigationDetailsRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationUpdateInvestigationDetailsPost(body?: InvestigationDetailsRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationUpdateInvestigationDetailsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
